<template>
  <v-row
    align="center"
    justify="center"
  >
    <slot name="trigger"></slot>

    <v-overlay
      :value="popup"
      opacity="0.5"
    >
      <v-card light width="500">
        <v-container class="px-5">
          <div>
            <div class="full-width d-flex justify-end">
              <v-btn icon @click="closePopUp">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>

            <HorseTableFilter v-if="isHorse" />

            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              class="pb-4 pt-0 mt-0"
              @click.stop
            />

            <v-data-table
              id="tablepopup"
              v-model="newValue"
              :items="items"
              :search="search"
              :hide-default-footer="true"
              :items-per-page="-1"
              :headers="headers"
              height="530"
              show-select
              item-key="uuid"
              item-text="label"
              :single-select="singleSelection"
              :custom-filter="filter"
              @click:row="rowClick"
            >
              <template v-if="isHorse" #item.dailyEffort="{ item }">
                <v-col cols="12" class="light-pink-bg text-center">
                  {{ item.dailyEffort }}
                </v-col>
              </template>
              <template v-if="isHorse" #item.weeklyEffort="{ item }">
                <v-col cols="12" class="dark-pink-bg text-center">
                  {{ item.weeklyEffort }}
                </v-col>
              </template>
            </v-data-table>

            <div class="flex text-end mt-2">
              <v-btn
                color="third"
                outlined
                rounded
                class="font-weight-bold my-3"
                @click="confirmSelection"
              >
                <v-icon size="24" color="third">mdi-plus</v-icon>
                Ajouter
              </v-btn>
            </div>
          </div>
        </v-container>
      </v-card>
    </v-overlay>
  </v-row>
</template>

<script>
import { ref, watch } from '@vue/composition-api';
import HorseTableFilter from '@/components/ParticipantHorse/HorseTableFilter.vue';

export default {
  components: { HorseTableFilter },
  props: {
    isModalOpen: { type: Boolean },
    items: {
      type: Array,
      default: () => []
    },
    value: {
      type: [Array, String],
      default: () => null
    },
    isSingleSelect: { type: Boolean },
    wtype: {
      type: String,
      default: ''
    },
    headers: {
      type: Array,
      default: () => []
    },
    item: {
      type: Object,
      default: () => {}
    },
    isHorse: {
      type: Boolean,
      default: false
    }
  },
  setup (props, context) {
    const search = ref(null);
    const popup = ref(props.isModalOpen);
    const newValue = ref(props.value || []);
    const singleSelection = ref(props.isSingleSelect);

    const closePopUp = () => popup.value = false;

    const confirmSelection = () => {
      if (singleSelection.value) {
        context.emit('confirmSelection', { type: props.wtype, selectedItems: newValue.value, isSingleSelect: true });
        return;
      }
      context.emit('input', newValue.value);
      context.emit('confirmSelection', { type: props.wtype, selectedItems: newValue.value, isSingleSelect: false });
    };

    const filter = (_, searchValue, item) => item.label.toLowerCase().includes(searchValue.toLowerCase());

    const rowClick = (item, row) => {
      event.stopPropagation();
      row.select(!row.isSelected);
    };

    watch(() => props.value, () => {
      newValue.value = props.value;
    });

    watch(() => props.isSingleSelect, () => {
      singleSelection.value = props.isSingleSelect;
    });

    watch(() => props.isModalOpen, () => {
      popup.value = props.isModalOpen;
    });

    watch(popup, () => {
      context.emit('modalChangeState', { modalValue: popup.value, type: props.wtype, singleSelect: singleSelection.value });
    });

    return { closePopUp, newValue, popup, search, confirmSelection, filter, rowClick, singleSelection };
  }
};

</script>
